import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-sand py-12 sm:py-14" data-id="element-107" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-2xl px-5" data-id="element-108" data-mp="4vjn44ww56f5">
        <div className="flex flex-col items-center gap-4 rounded-2xl border border-gold/40 bg-ivory p-6 text-center sm:flex-row sm:gap-5 sm:p-7 sm:text-left" data-id="element-109" data-mp="9ttiogmj291a">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-sand ring-1 ring-stone-deep" data-id="element-110" data-mp="ercwxgj86lt8">
            <ShieldCheckIcon className="h-6 w-6 text-gold-deep" aria-hidden data-id="element-111" data-mp="ntvzdzj3mwey" />
          </span>
          <div data-id="element-112" data-mp="skujla77kenh">
            <h2 className="font-display text-xl font-semibold text-charcoal sm:text-2xl" data-id="element-113" data-mp="skcdlluqum2d">
              Garantía <span className="font-sans font-bold tabular-nums" data-id="element-114" data-mp="xkgwfij4jsvr">7</span> días — sin
              preguntas
            </h2>
            <p className="mt-2 font-sans text-[0.85rem] leading-relaxed text-charcoal/70" data-id="element-115" data-mp="12kbj19vv9wb0">
              Abrís los tomos. Los aplicás en tu perfil. Si en 7 días no es lo que esperabas:{' '}
              <strong className="font-semibold text-charcoal" data-id="element-116" data-mp="25syjqqmtreg6">devolución del 100%</strong> sin
              formularios, sin drama.
            </p>
          </div>
        </div>
      </div>
    </section>;
}